import styled from 'styled-components';
import { isCorClara } from '../../util/color';

export const ListaCartaServicosBox = styled.div`
  text-align: center;
  color: ${({ corFundo }) => (isCorClara(corFundo) ? '#000' : '#fff')};
  background-color: ${({ corFundo }) => corFundo || 'rgb(240 240 240)'};
  border-radius: 5px;
  box-shadow: 0px 0px 5px #dfdfdf;
  padding: 14px 8px;
  min-height: 115px;
  transition: all 300ms ease-in-out;
  height: 100%;
  
  :hover {
    box-shadow: 4px 4px 10px 0px rgb(0 0 0 / 10%);
  }
`;

export const ListaCartaServicosTitulo = styled.p`
  font-size: 0.86em;
  font-weight: bold;
  margin: 0;
`;

export const ListaCartaServicosSecretaria = styled.p`
  font-size: 14px;
  margin-bottom: 0;
`;
